export default require("../../app/Pages/Home.purs").mkHome();
export const Head = require("../../app/Pages/Home.purs").mkHead();